import { render, staticRenderFns } from "./ClaimGasLoadingTransactionStep.vue?vue&type=template&id=3e484236&scoped=true"
import script from "./ClaimGasLoadingTransactionStep.vue?vue&type=script&lang=ts"
export * from "./ClaimGasLoadingTransactionStep.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e484236",
  null
  
)

export default component.exports